<template>
<v-container fluid grid-list-lg style="min-height:100%">

  <span class="centerized title grey--text text-xs-center" v-if="!loading && allMacros.length===0">{{ $t('reactor.no_macro_available') }}</span>

  <span class="centerized title grey--text text-xs-center" v-else-if="!loading && filteredMacros.length===0">{{ $t('reactor.no_macro_matched') }}</span>

  <v-layout row wrap v-else-if="!loading">
    <v-flex xl2 lg3 md4 sm6 xs12 v-for="m in filteredMacros" :key="m.key">
      <macro-item :item="m" @click="itemClicked"></macro-item>
    </v-flex>
  </v-layout>

  <macro-reflect v-if="dialogReflect" v-model="dialogReflect" :item="dialogItem"></macro-reflect>

  <macro-editor v-if="dialogEditor" v-model="dialogEditor" :item="dialogItem" @toast="val=>$emit('toast',val)"></macro-editor>

  <macro-creator v-if="dialogCreator" v-model="dialogCreator" :item="dialogItem" @create="onMacroCreated" @toast="val=>$emit('toast',val)"></macro-creator>

  <v-menu v-model="showMenu" :position-x="menuX" :position-y="menuY" absolute offset-y>
    <v-list>
      <v-list-tile avatar @click="dialogEditor=true">
        <v-list-tile-avatar>
          <v-icon color="primary">edit</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-title>{{ $t('reactor.edit') }}</v-list-tile-title>
      </v-list-tile>
      <v-list-tile avatar @click="dialogReflect=true">
        <v-list-tile-avatar>
          <v-icon color="primary">link</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-title>{{ $t('reactor.reflect') }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>

  <v-btn color="secondary" dark fixed bottom right fab @click="dialogCreator=true" v-if="!loading">
    <v-icon>add</v-icon>
  </v-btn>

  <progress-dialog :visible="loading">{{ $t('loading') }}</progress-dialog>

</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import MacroItem from '@/components/reactor/MacroItem'
import MacroReflectDialog from '@/components/reactor/MacroReflectDialog'
import MacroEditorDialog from '@/components/reactor/MacroEditorDialog'
import MacroCreatorDialog from '@/components/reactor/MacroCreatorDialog'

export default {
  name: 'Macro',
  mixins: [UserAuth],
  components: {
    'macro-item': MacroItem,
    'macro-reflect': MacroReflectDialog,
    'macro-editor': MacroEditorDialog,
    'macro-creator': MacroCreatorDialog
  },
  data() {
    return {
      userMacroScene: {},
      dialogItem: null,
      dialogReflect: false,
      dialogEditor: false,
      dialogCreator: false,
      showMenu: false,
      menuX: 0,
      menuY: 0
    }
  },
  computed: {
    loading() {
      return this.macroLoading;
    },
    allMacros() {
      let list = [];
      Object.keys(this.userMacro).forEach(mac => {
        let macro = this.userMacro[mac] || {};
        Object.values(macro).forEach(m => {
          let key = `${mac}-${Buffer.from(m.title).toString('base64')}`
          list.push({
            ...m,
            key: key,
            mac: mac,
            enabled: m.enabled || this.checkScheduleEnable("!@_mix_", m.title),
            has_schedule: this.findScheduleIndexByTitle("!@_mix_", m.title) === -1 ? 0 : 1,
            mix_schedule_enabled: this.checkScheduleEnable("!@_mix_", m.title),
            date_schedule_enabled: this.checkScheduleEnable("!@_date_", m.title),
            actived: this.userMacroScene[key]
          });
        });
      });
      return list.sort((a, b) => a.key.localeCompare(b.key));;
    },
    allMacroSchedule() {
      let list = [];
      Object.keys(this.userMacroSchedule).forEach(mac => {
        let macroSchedule = this.userMacroSchedule[mac] || {};
        Object.values(macroSchedule).forEach(ms => {
          list.push({enabled: ms.enabled, title: ms.title})
        });
      });
      return list
    },
    filteredMacros() {
      let data = this.allMacros;
      if (data) {
        if (this.searchGateway && this.searchGateway.length > 0)
          data = data.filter(item => item.mac === this.searchGateway);

        if (this.searchKeyword && this.searchKeyword.length > 0)
          data = data.filter(item => ((item.title || '').toLowerCase()).indexOf(this.searchKeyword.toLowerCase()) != -1);
      }
      return data;
    }
  },
  methods: {
    itemClicked(item, e) {
      this.dialogItem = item;
      this.menuX = e.clientX;
      this.menuY = e.clientY;
      this.showMenu = true;
    },
    onMacroCreated(key) {
      this.dialogItem = this.allMacros.find(s => s.key == key);
      this.dialogEditor = true;
    },
    findScheduleIndexByTitle(prefix ,title) {
      return this.allMacroSchedule.map(u => u.title).indexOf(prefix + title);
    },
    checkScheduleEnable(prefix ,title) {
      return this.findScheduleIndexByTitle(prefix ,title) === -1 ? 0 : this.allMacroSchedule[this.findScheduleIndexByTitle(prefix ,title)].enabled;
    }
  },
  mounted() {
    this.$bindAsObject('userMacroScene', this.$db.ref('userMacroScene').child(this.userId));
  },
  beforeDestroy() {
    this.$db.ref('userMacroScene').child(this.userId).off();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/reactor/Macro.vue